module.exports = __webpack_public_path__ + "static/media/group-desktop.75405865.svg";